import { render, staticRenderFns } from "./depositIncome.vue?vue&type=template&id=11f5131e&scoped=true&lang=pug"
import script from "./depositIncome.vue?vue&type=script&lang=js"
export * from "./depositIncome.vue?vue&type=script&lang=js"
import style0 from "./depositIncome.vue?vue&type=style&index=0&id=11f5131e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11f5131e",
  null
  
)

export default component.exports